// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-11-27 00:57:15 +0100 (Thu, 27 Nov 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 158690 $
//  Purpose   : mods package
// =============================================================================
export const parts = true
export const nodemenu = true

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as views from './views'
export {views}
